var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.914917 19.0638C0.914917 29.5925 9.45008 38.1277 19.9787 38.1277C30.5074 38.1277 39.0426 29.5925 39.0426 19.0638C39.0426 8.53517 30.5074 0 19.9787 0C9.45008 0 0.914917 8.53517 0.914917 19.0638Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7362 28.5951H10.6851V15.8461H14.7362V28.5951ZM12.7107 14.0589C11.4 14.0589 10.4468 13.1057 10.4468 11.7951C10.4468 10.4844 11.5192 9.53125 12.7107 9.53125C14.0213 9.53125 14.9745 10.4844 14.9745 11.7951C14.9745 13.1057 14.0213 14.0589 12.7107 14.0589ZM29.5107 28.5951H25.4596V21.6844C25.4596 19.6589 24.6256 19.0632 23.4341 19.0632C22.2426 19.0632 21.0511 20.0164 21.0511 21.8036V28.5951H17V15.8461H20.8128V17.6334C21.1702 16.7993 22.6 15.4887 24.6256 15.4887C26.8894 15.4887 29.2724 16.7993 29.2724 20.7312V28.5951H29.5107Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e6133f71eb4f76a9fdb10593e446724d.svg";
export { ForwardRef as ReactComponent };